import $ from "utils/net";
import { ManualWithdrawFormData, ManualWithdrawMaxAmount } from "./types";

interface ApiResponse<T> {
    status: string;
    errors?: string[];
    data?: T;
}

export class ManualWithdrawService {
    constructor(private readonly endpoint: string) {}

    async getMaxAmount(): Promise<ManualWithdrawMaxAmount> {
        const res = await new Promise<ApiResponse<ManualWithdrawMaxAmount>>((res, rej) =>
            $.getJSON(this.endpoint + '/manual_deposit/getWithdrawalMaxAmount', (err, data) =>
                err ? rej(err) : res(data)
            )
        );
        if (res.status !== 'ok' || !res.data) throw new Error('Failed to load max amount');
        return res.data;
    }

    async requestWithdrawal(data: ManualWithdrawFormData): Promise<string> {
        const body: Record<string, string> = {
            telebirr_address: data.telebirr_address,
            amount: data.amount,
        };

        const res = await new Promise<ApiResponse<{ id: string }>>((res, rej) =>
            $.post(this.endpoint + '/manual_deposit/manualWithdraws', {
                body,
                json: true,
            }, (err, data) =>
                err ? rej(err) : res(data)
            )
        );
        if (res.status !== 'ok') {
            throw new Error(res.errors?.[0] || 'Withdrawal request failed');
        }
        return res.data!.id;
    }
}
